const GENERATE_REQUEST_DOWNLOAD_FILES = 'GENERATE_REQUEST_DOWNLOAD_FILES';
const SET_DATA_DOWNLOAD_FILES = 'SET_DATA_DOWNLOAD_FILES';
const GET_DOWNLOADED_FILES = 'GET_DOWNLOADED_FILES';
const SET_DOWNLOADED_FILES = 'SET_DOWNLOADED_FILES';
const GET_ZIP_FROM_PATH = 'GET_ZIP_FROM_PATH';
const UPDATE_DOWNLOADS_PAGINATION = 'UPDATE_DOWNLOADS_PAGINATION';
const UPDATE_FILTERED_DOWNLOADS_PAGINATION = 'UPDATE_FILTERED_DOWNLOADS_PAGINATION';
const NOTIFICATION_SENT = 'NOTIFICATION_SENT';
const GET_FILTERED_DOWNLOADED_FILES = 'GET_FILTERED_DOWNLOADED_FILES';
const SET_FILTERED_DOWNLOADED_FILES = 'SET_FILTERED_DOWNLOADED_FILES';
const GET_EFOS_REQUEST_DATA = 'GET_EFOS_REQUEST_DATA';
const SET_EFOS_REQUEST_DATA = 'SET_EFOS_REQUEST_DATA';
const UPDATE_EFOS_DATA_FORM = 'UPDATE_EFOS_DATA_FORM';
const CREATE_EFOS_REQUEST = 'CREATE_EFOS_REQUEST';
const RESTART_EFOS_STATE = 'RESTART_EFOS_STATE';
const GET_LAST_EFOS_REQUEST = 'GET_LAST_EFOS_REQUEST';
const SET_LAST_EFOS_REQUEST = 'SET_LAST_EFOS_REQUEST';
const SET_FILTERED_DATA = 'SET_FILTERED_DATA';
const REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD';

const generateRequestDownloadFiles = data => {
    return {
        type: GENERATE_REQUEST_DOWNLOAD_FILES,
        data
    };
}

const setDataDownloadFiles = data => {
    return {
        type: SET_DATA_DOWNLOAD_FILES,
        data
    };
}

const getDownloadedFiles = (query) => {
    return {
        type: GET_DOWNLOADED_FILES,
        query
    };
}

const getFilteredDownloadedFiles = (query) => {
    return {
        type: GET_FILTERED_DOWNLOADED_FILES,
        query
    };
}

const setDownloadedFiles = data => {
    return {
        type: SET_DOWNLOADED_FILES,
        data
    };
}

const setFilteredDownloadedFiles = data => {
    return {
        type: SET_FILTERED_DOWNLOADED_FILES,
        data
    };
}

const getZipFromPath = filePath => {
    return {
        type: GET_ZIP_FROM_PATH,
        filePath
    };
}

const updateDownloadsPagination = data => {
    return {
        type: UPDATE_DOWNLOADS_PAGINATION,
        data
    }
}

const updateFilteredDownloadsPagination = data => {
    return {
        type: UPDATE_FILTERED_DOWNLOADS_PAGINATION,
        data
    }
}

const notificationSent = status => {
    return {
        type: NOTIFICATION_SENT,
        status
    }
}

const getEfosRequestData = data => {
    return {
        type: GET_EFOS_REQUEST_DATA,
        data,
    };
}

const setEfosRequestData = data => {
    return {
        type: SET_EFOS_REQUEST_DATA,
        data,
    };
}

const updateEfosDataForm = data => {
    return {
        type: UPDATE_EFOS_DATA_FORM,
        data,
    };
}

const createEfosRequest = data => {
    return {
        type: CREATE_EFOS_REQUEST,
        data,
    };
}

const restartEfosState = () => {
    return { 
        type: RESTART_EFOS_STATE,
    };
}

const getLastEfos = (data) => {
    return {
        type: GET_LAST_EFOS_REQUEST,
        data
    }
}

const setLastEfos = (data) => {
    return {
        type: SET_LAST_EFOS_REQUEST,
        data
    }
}

const setFilteredData = data => {
    return {
        type: SET_FILTERED_DATA,
        data
    };
}

const requestChangePassword = data => {
    return {
        type: REQUEST_CHANGE_PASSWORD,
        data
    };
}


export default {
    types: {
        GENERATE_REQUEST_DOWNLOAD_FILES,
        SET_DATA_DOWNLOAD_FILES,
        GET_DOWNLOADED_FILES,
        GET_FILTERED_DOWNLOADED_FILES,
        SET_FILTERED_DOWNLOADED_FILES,
        SET_DOWNLOADED_FILES,
        GET_ZIP_FROM_PATH,
        UPDATE_DOWNLOADS_PAGINATION,
        UPDATE_FILTERED_DOWNLOADS_PAGINATION,
        NOTIFICATION_SENT,
        GET_EFOS_REQUEST_DATA,
        SET_EFOS_REQUEST_DATA,
        UPDATE_EFOS_DATA_FORM,
        CREATE_EFOS_REQUEST,
        RESTART_EFOS_STATE,
        GET_LAST_EFOS_REQUEST,
        SET_LAST_EFOS_REQUEST,
        SET_FILTERED_DATA,
        REQUEST_CHANGE_PASSWORD
    },
    actions: {
        generateRequestDownloadFiles,
        setDataDownloadFiles,        
        getDownloadedFiles,
        getFilteredDownloadedFiles,
        setFilteredDownloadedFiles,
        setDownloadedFiles,        
        getZipFromPath,    
        updateDownloadsPagination,
        updateFilteredDownloadsPagination,
        notificationSent,
        getEfosRequestData,
        setEfosRequestData,
        updateEfosDataForm,
        createEfosRequest,
        restartEfosState,
        getLastEfos,
        setLastEfos,
        setFilteredData,
        requestChangePassword
    }
}